<div class="detail-page-card">
    <div class="detail-page-card-title">{{ 'linkedMoiOverview.measuresOfImprovementsTitle' | t }}</div>

    <div [class.d-none]="!linkedMois">
        <div class="detail-page-card-actions flexme">
            <div>
                @if (canAdd) {
                    <button
                        class="btn btn-raised"
                        data-uiid="moi-linkable-add-button"
                        (click)="addMoi()"
                    >
                        <i class="fas fa-plus-circle"></i>
                        <span>{{ 'linkedMoiOverview.addMoiBtn' | t }}</span>
                    </button>
                }
                @if (canDelete) {
                    <button
                        class="btn btn-raised red"
                        data-uiid="moi-linkable-delete-button"
                        (click)="deleteMoi()"
                        [disabled]="!activeRow"
                    >
                        <i class="fas fa-times-circle"></i>
                        <span>{{ 'linkedMoiOverview.deleteMoiBtn' | t }}</span>
                    </button>
                }
            </div>
            <div>
                <button
                    class="btn btn-raised float-end"
                    data-uiid="moi-linkable-reload-button"
                    (click)="load(true)"
                >
                    <i class="fas fa-sync"></i>
                    <span>{{ 'linkedMoiOverview.reloadBtn' | t }}</span>
                </button>
            </div>
        </div>

        <div class="detail-page-card-body">
            <cerrix-table
                [idProp]="'guid'"
                [config]="overviewConfig"
                [rendererConfig]="rendererConfig"
                [activeRow]="activeRow"
                [Centered]="true"
                [NoPadding]="true"
                [NoBorder]="true"
                data-uiid="moi-linkable-table"
                (activeRowChange)="activeRow = $event"
                (rowDblClick)="openMoi($event)"
                #cerrixTableComponent
            >
            </cerrix-table>
        </div>
    </div>
    @if (!linkedMois) {
        <div class="p-3">
            <div class="fancy-loader submodule"></div>
        </div>
    }
</div>
